import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.timers.js";
export default {
  name: 'InstallPWA',
  data: function data() {
    return {
      isInstalling: false,
      tempMessage: 'Nothing',
      showOptOut: false,
      isAndroid: false,
      isIOS: false,
      canInstallFromButton: false,
      showInstallPrompt: false,
      showIOSChromeModal: false,
      deferredPrompt: null
    };
  },
  setup: function setup() {
    return {};
  },
  computed: {
    installTitle: function installTitle() {
      if (this.isAndroid) return 'Install for Android';
      if (this.isIOS) return 'Install for iPhone';
      return 'Install Application';
    }
  },
  methods: {
    optOut: function optOut() {
      localStorage.setItem('pwaOptedOut', true);
      this.showInstallPrompt = false;
      this.showIOSChromeModal = false;
    },
    handleBeforeInstallPromptEvent: function handleBeforeInstallPromptEvent(e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstallFromButton = true;
    },
    beforeDestroy: function beforeDestroy() {
      // Optionally, you can remove the event listener when the component is destroyed
      window.removeEventListener("beforeinstallprompt", this.handleBeforeInstallPromptEvent);
    },
    installApplication: function installApplication() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$_this$deferred, outcome;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (_this.deferredPrompt) {
                _context.next = 4;
                break;
              }
              _this.tempMessage = 'No deferred prompt';
              return _context.abrupt("return");
            case 4:
              _this.deferredPrompt.prompt();
              _context.next = 7;
              return _this.deferredPrompt.userChoice;
            case 7:
              _yield$_this$deferred = _context.sent;
              outcome = _yield$_this$deferred.outcome;
              if (outcome === 'accepted') {
                _this.isInstalling = true;
                // this.$store.commit('updateAppIsInstalling', true);
                // localStorage.setItem('pwaOptedOut', 'true');
              } else {
                // this.$store.commit('updateAppIsInstalling', false);
                _this.isInstalling = false;
              }
              _this.deferredPrompt = null;
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              _this.tempMessage = _context.t0;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }))();
    },
    // async installPwa() {
    //     try{
    //     if (this.deferredPrompt) {
    //         console.log('trying to install');
    //         this.deferredPrompt.prompt();
    //         const { outcome } = await this.deferredPrompt.userChoice;
    //         if (outcome === 'accepted') {
    //             console.log('User accepted the install prompt');
    //         } else {
    //             console.log('User dismissed the install prompt');
    //         }
    //         this.deferredPrompt = null;
    //         this.showInstallPrompt = false;
    //     } else {
    //         console.log('No deferred prompt');
    //     }
    // } 
    // catch(err){ // let isWindows = /windows phone/i.test(navigator.userAgent.toLowerCase());
    //     this.tempMessage = err;
    // }
    // },
    closeModal: function closeModal() {
      this.showInstallPrompt = false;
      this.showIOSChromeModal = false;
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    console.log('<<<<<<<<< installPWA mounted >>>>>>>>>');
    // determine if ios 
    // let isWindows = /windows phone/i.test(navigator.userAgent.toLowerCase());

    window.addEventListener("beforeinstallprompt", function (e) {
      e.preventDefault();
      _this2.deferredPrompt = e;
      // Show install prompt only when beforeinstallprompt is captured
    });
    // Check if the app is running as a standalone PWA
    if (!(window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true)) {
      var pwaOptedOut;
      try {
        pwaOptedOut = localStorage.getItem("pwaOptedOut");
      } catch (err) {
        pwaOptedOut = 'false';
      }
      if (pwaOptedOut == 'true') {
        return;
      }
      var pwaInstallAttempts;
      try {
        pwaInstallAttempts = localStorage.getItem("pwaInstallAttempts");
      } catch (err) {
        pwaInstallAttempts = '0';
      }
      if (pwaInstallAttempts) {
        pwaInstallAttempts = parseInt(pwaInstallAttempts);
        console.log('pwaInstallAttempts', pwaInstallAttempts);
        if (pwaInstallAttempts > 2) {
          console.log('showing opt out');
          setTimeout(function () {
            _this2.showOptOut = true;
          }, 2000);
        } else {
          console.log('not showing', pwaInstallAttempts);
        }
        pwaInstallAttempts++;
        localStorage.setItem("pwaInstallAttempts", pwaInstallAttempts);
      } else {
        localStorage.setItem("pwaInstallAttempts", '0');
      }
      // Capture the install prompt

      setTimeout(function () {
        // if(this.canInstallFromButton || true){
        // determine if android phone and mobile
        var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1 && navigator.userAgent.toLowerCase().indexOf("mobile") > -1;
        _this2.isAndroid = isAndroid;

        // Detect iOS and browser
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        _this2.isIOS = isIOS;
        var isChromeIOS = isIOS && /CriOS/.test(navigator.userAgent);

        // Check if on iOS with Chrome browser
        if (isChromeIOS) {
          _this2.showIOSChromeModal = true;
        } else if (_this2.deferredPrompt) {
          // this.showIOSChromisIOSeModal = true;
          _this2.showInstallPrompt = true;
          _this2.tempMessage = 'showing install prompt';
        } else {
          if (_this2.isIOS && !_this2.isChromeIOS) {
            _this2.showInstallPrompt = true;
          }
          console.log('not showing it');
          _this2.tempMessage = 'Not showing it';
        }
        // }
      }, 5000);
    } else {
      console.log('not showing main loop');
      this.tempMessage = 'Not showing main loop';
    }
  }
};